export const IMAGE_SEARCH_SET_IMAGES = 'IMAGE_SEARCH_SET_IMAGES';
export const IMAGE_SEARCH_ADD_IMAGES = 'IMAGE_SEARCH_ADD_IMAGES';
export const IMAGE_SEARCH_SET_ARE_IMAGES_LOADING = 'IMAGE_SEARCH_SET_ARE_IMAGES_LOADING';
export const IMAGE_SEARCH_SET_SEARCH = 'IMAGE_SEARCH_SET_SEARCH';
export const IMAGE_SEARCH_SET_IMAGE_SOURCE = 'IMAGE_SEARCH_SET_IMAGE_SOURCE';
export const IMAGE_SEARCH_RESET_STATE = 'IMAGE_SEARCH_RESET_STATE';
